import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import { CountryDataSet, toCountryDataSet } from '@/primary/country/CountryDataSet';
import { Store } from '@/primary/store/Store';
import { MittClickBus } from '@/primary/MittClickBus';
import { Unsubscribe } from '@/domain/Unsubscribe';
import { OLClickSelect } from '@/primary/webmapping/common/OLClickSelect';

@Component
export default class CountryAutocompleteComponent extends Vue {
  text = '';
  selectableCountryDataSets: CountryDataSet[] = [];
  unsubscribeClickBus!: Unsubscribe;
  preSelectedCountryId = '';

  @Inject()
  store!: () => Store;

  @Inject()
  countryOLSelect!: () => OLClickSelect;

  @Inject()
  clickBus!: () => MittClickBus;

  @Watch('text')
  textWatcher() {
    this.selectableCountryDataSets =
      this.text === ''
        ? []
        : this.countryDataSets
            .filter(country => country.name.toLowerCase().indexOf(this.text.toLowerCase()) > -1)
            .sort((dataSet1, dataSet2) => (dataSet1.name.toLowerCase() < dataSet2.name.toLowerCase() ? -1 : 1))
            .slice(0, 10);
  }

  get countries() {
    return this.store().getCountries();
  }

  get projectCountsByCountry() {
    return this.store().getProjectCountsByCountry();
  }

  get countryDataSets() {
    return this.countries.filter(country => this.projectCountsByCountry[country.id]).map(toCountryDataSet);
  }

  created(): void {
    this.unsubscribeClickBus = this.clickBus().onClick(mouseEvent => this.clicked(mouseEvent.target as Element));
  }

  beforeDestroy(): void {
    this.unsubscribeClickBus();
  }

  private clicked(target: Element) {
    const dropdownElement = this.$refs.dropdown as Element;
    if (!dropdownElement.contains(target)) {
      this.selectableCountryDataSets = [];
    }
  }

  public keyDown() {
    const preSelectedIndex = this.selectableCountryDataSets.findIndex(country => country.id === this.preSelectedCountryId);
    if (preSelectedIndex < this.selectableCountryDataSets.length - 1) {
      this.preSelectedCountryId = this.selectableCountryDataSets[preSelectedIndex + 1].id;
    }
  }

  public keyUp() {
    const preSelectedIndex = this.selectableCountryDataSets.findIndex(country => country.id === this.preSelectedCountryId);
    if (preSelectedIndex > 0) {
      this.preSelectedCountryId = this.selectableCountryDataSets[preSelectedIndex - 1].id;
    }
  }

  public async selectCountry(country: CountryDataSet) {
    this.text = country.name;
    await this.$nextTick();
    this.selectableCountryDataSets = [];
    this.countryOLSelect().select(country.id);
  }

  public async selectPreselected() {
    await this.selectCountry(this.selectableCountryDataSets.find(country => country.id === this.preSelectedCountryId)!);
  }
}
